import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { PlusIcon, SearchIcon } from 'lucide-react';
import { Button, buttonClasses } from '../../components/ui/Button';
import { TextField } from '../../components/ui/Field';
import { useAdminData } from '../../contexts/AdminDataContext';
import { formatDate } from '../../utils/format';
const ease = [0.23, 1, 0.32, 1] as const;
export function Customers() {
  const {
    customers,
    casesForCustomer,
    createCustomer
  } = useAdminData();
  const [query, setQuery] = useState('');
  const [creating, setCreating] = useState(false);
  const [form, setForm] = useState({
    name: '',
    phone: '',
    email: '',
    address: '',
    notes: ''
  });
  const term = query.trim().toLowerCase();
  const visible = customers.filter(customer => !term ? true : `${customer.name} ${customer.phone} ${customer.email} ${customer.address}`.toLowerCase().includes(term));
  return <div className="px-5 py-7 md:px-8 md:py-10" data-id="element-440" data-mp="1gskdj2ond6e0">
      <div className="flex flex-wrap items-end justify-between gap-4" data-id="element-441" data-mp="1gr99r2v7bymw">
        <div data-id="element-442" data-mp="1crib6czfoe7t">
          <p className="text-sm text-ink-muted" data-id="element-443" data-mp="1cpxkwzk5jhfr">{customers.length} kunder</p>
          <h1 className="mt-1 font-display text-[clamp(1.8rem,5vw,2.5rem)] font-bold leading-[1.05] tracking-tight text-ink" data-id="element-444" data-mp="1qiwxotsjuxjm">
            Kunder
          </h1>
        </div>
        <Button size="md" onClick={() => setCreating(value => !value)} data-id="element-445" data-mp="1lln18u6qtlma">
          <PlusIcon className="h-4 w-4" aria-hidden="true" data-id="element-446" data-mp="xtzsnsdcmx8t" />
          Opret kunde
        </Button>
      </div>

      {creating && <motion.form initial={{
      opacity: 0,
      y: -8
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.24,
      ease
    }} className="mt-6 rounded-card border border-line bg-white p-6" onSubmit={event => {
      event.preventDefault();
      createCustomer(form);
      setForm({
        name: '',
        phone: '',
        email: '',
        address: '',
        notes: ''
      });
      setCreating(false);
    }} data-id="element-447" data-mp="17rvxk2fp0vyh">
          <h2 className="font-display text-lg font-bold tracking-tight text-ink" data-id="element-448" data-mp="2m84dtpetl4e5">Ny kunde</h2>
          <div className="mt-5 grid gap-5 sm:grid-cols-2" data-id="element-449" data-mp="2q8o88l80dtwl">
            <TextField id="nk-navn" label="Navn" required value={form.name} onChange={event => setForm({
          ...form,
          name: event.target.value
        })} data-id="element-450" data-mp="2v8u4yft4y6lj" />
            <TextField id="nk-tlf" label="Telefonnummer" type="tel" value={form.phone} onChange={event => setForm({
          ...form,
          phone: event.target.value
        })} data-id="element-451" data-mp="22lzixego6z5y" />
            <TextField id="nk-mail" label="E-mail" type="email" value={form.email} onChange={event => setForm({
          ...form,
          email: event.target.value
        })} data-id="element-452" data-mp="2ch18gbeuy392" />
            <TextField id="nk-adresse" label="Adresse" value={form.address} onChange={event => setForm({
          ...form,
          address: event.target.value
        })} data-id="element-453" data-mp="1osi05vvt5qgz" />
            <TextField id="nk-noter" label="Noter" className="sm:col-span-2" value={form.notes} onChange={event => setForm({
          ...form,
          notes: event.target.value
        })} data-id="element-454" data-mp="1cbz4gvv7lw8b" />
          </div>
          <div className="mt-6 flex gap-3" data-id="element-455" data-mp="ybemg1x4c4fv">
            <Button type="submit" data-id="element-456" data-mp="ycfxi6e4wqxl">Gem kunde</Button>
            <Button type="button" variant="secondary" onClick={() => setCreating(false)} data-id="element-457" data-mp="tkg0omtd2e58">
              Annuller
            </Button>
          </div>
        </motion.form>}

      <div className="mt-6" data-id="element-458" data-mp="oiqtxjd68mmy">
        <label htmlFor="kundesoeg" className="sr-only" data-id="element-459" data-mp="jmiee4v2arf9">
          Søg i kunder
        </label>
        <div className="flex items-center gap-2 rounded-xl border border-line bg-white px-4 py-3" data-id="element-460" data-mp="enf8ki79ch68">
          <SearchIcon className="h-4 w-4 shrink-0 text-ink-faint" aria-hidden="true" data-id="element-461" data-mp="aksgcg6ocu8i" />
          <input id="kundesoeg" value={query} onChange={event => setQuery(event.target.value)} placeholder="Søg på navn, telefon, mail eller adresse" className="w-full bg-transparent text-[15px] text-ink placeholder:text-ink-faint focus:outline-none" data-id="element-462" data-mp="zc85x89gzenr" />
        </div>
      </div>

      <div className="mt-6 rounded-card border border-line bg-white" data-id="element-463" data-mp="ujoscbas8jiy">
        <div className="hidden md:block" data-id="element-464" data-mp="gl750eosh91k">
          <table className="w-full text-left text-[15px]" data-id="element-465" data-mp="gnjncsygllf5">
            <thead data-id="element-466" data-mp="lll4h8cbranz">
              <tr className="border-b border-line text-xs uppercase tracking-wider text-ink-muted" data-id="element-467" data-mp="lm4msq5w012j">
                <th scope="col" className="px-5 py-3 font-medium" data-id="element-468" data-mp="7md3qb0ijuho">Navn</th>
                <th scope="col" className="px-5 py-3 font-medium" data-id="element-469" data-mp="bnf5ayhwkimt">Telefon</th>
                <th scope="col" className="px-5 py-3 font-medium" data-id="element-470" data-mp="21y9zgg5znmij">E-mail</th>
                <th scope="col" className="px-5 py-3 font-medium" data-id="element-471" data-mp="21wys66dc3wmo">Adresse</th>
                <th scope="col" className="px-5 py-3 font-medium" data-id="element-472" data-mp="25zlp2lov47qq">Sager</th>
                <th scope="col" className="px-5 py-3 font-medium" data-id="element-473" data-mp="3qj8tsn3o6vkd">Seneste sag</th>
                <th scope="col" className="px-5 py-3" data-id="element-474" data-mp="3mhnaaiwmrj17" />
              </tr>
            </thead>
            <tbody className="divide-y divide-line" data-id="element-475" data-mp="434i4t0zxjcc">
              {visible.map(customer => {
              const list = casesForCustomer(customer.id);
              const latest = [...list].sort((a, b) => b.createdAt.localeCompare(a.createdAt))[0];
              return <tr key={customer.id} className="transition-colors duration-200 ease-smooth hover:bg-canvas" data-id="element-476" data-mp="927mscd2dnjs">
                    <td className="px-5 py-3.5 font-medium text-ink" data-id="element-477" data-mp="n1yyu7k0stv5">{customer.name}</td>
                    <td className="whitespace-nowrap px-5 py-3.5 text-ink-soft" data-id="element-478" data-mp="i247y408w4a3">{customer.phone || '—'}</td>
                    <td className="px-5 py-3.5 text-ink-soft" data-id="element-479" data-mp="2osadhkwei8ow">{customer.email || '—'}</td>
                    <td className="px-5 py-3.5 text-ink-soft" data-id="element-480" data-mp="2juin4vbemumt">{customer.address || '—'}</td>
                    <td className="px-5 py-3.5 text-ink-soft" data-id="element-481" data-mp="nr46hub2qb85">{list.length}</td>
                    <td className="px-5 py-3.5 text-ink-soft" data-id="element-482" data-mp="nt7696213iq2">
                      {latest ? `${latest.title} · ${formatDate(latest.createdAt)}` : '—'}
                    </td>
                    <td className="px-5 py-3.5 text-right" data-id="element-483" data-mp="xnqpsenr4u82">
                      <Link to={`/admin/kunder/${customer.id}`} className={buttonClasses('secondary', 'sm')} data-id="element-484" data-mp="11qvoe64pobrf">
                        Åbn
                      </Link>
                    </td>
                  </tr>;
            })}
            </tbody>
          </table>
        </div>

        <ul className="divide-y divide-line md:hidden" data-id="element-485" data-mp="1gf9pabikhq5c">
          {visible.map(customer => {
          const list = casesForCustomer(customer.id);
          return <li key={customer.id} data-id="element-486" data-mp="1pghocvswqv0h">
                <Link to={`/admin/kunder/${customer.id}`} className="block px-5 py-4" data-id="element-487" data-mp="1ph9c5kg9jog7">
                  <p className="text-[15px] font-medium text-ink" data-id="element-488" data-mp="1uej3j5n7qa6o">{customer.name}</p>
                  <p className="mt-0.5 text-sm text-ink-muted" data-id="element-489" data-mp="3exv2fg0o5awf">{customer.phone}</p>
                  <p className="mt-1 text-sm text-ink-soft" data-id="element-490" data-mp="39y8qrb0ho2pq">
                    {list.length} {list.length === 1 ? 'sag' : 'sager'}
                  </p>
                </Link>
              </li>;
        })}
        </ul>

        {visible.length === 0 && <p className="px-5 py-12 text-center text-sm text-ink-muted" data-id="element-491" data-mp="30zeyfwu6xyhz">Ingen kunder matcher søgningen.</p>}
      </div>
    </div>;
}